import { faArrowAltCircleRight } from '@fortawesome/pro-solid-svg-icons';
import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { LinkOther } from '@sorare/core/src/atoms/navigation/Box';
import { HeroBlock } from '@sorare/core/src/components/landing/HeroBlock';

import heroBackgroundVideo from './assets/heroBackgroundVideo.webm';
import heroVideoPoster from './assets/heroVideoPoster.jpg';
import slideShow_1 from './assets/slideShow_1.jpg';
import slideShow_2 from './assets/slideShow_2.jpg';
import slideShow_3 from './assets/slideShow_3.jpg';
import slideShow_4 from './assets/slideShow_4.jpg';
import slideShow_5 from './assets/slideShow_5.jpg';

const messages = defineMessages({
  title: {
    id: 'Landing.NBA.Hero.title',
    defaultMessage: 'Fantasy Basketball.{br}Reimagined.',
  },
  subtitle: {
    id: 'Landing.NBA.Hero.subtitle',
    defaultMessage:
      'Sorare NBA is a next-level fantasy basketball game where you collect and compete with ownable digital player cards to win prizes like cash, tickets, signed jerseys, and more. No matter where you finish, you still own your cards.',
  },
  additionalCTAText: {
    id: 'Landing.NBA.Hero.additionalCTAText',
    defaultMessage: 'Fantasy Reimagined',
  },
});

const Icon = styled(FontAwesomeIcon)`
  margin-right: var(--unit);
`;

const StyledLink = styled(LinkOther)`
  &:hover {
    opacity: 0.8;
  }
`;

export const Hero = () => {
  const { formatMessage } = useIntl();

  return (
    <HeroBlock
      poster={heroVideoPoster}
      videoSrc={heroBackgroundVideo}
      subtitle={formatMessage(messages.subtitle)}
      title={formatMessage(messages.title, { br: <br /> })}
      mobileSlides={[
        slideShow_1,
        slideShow_2,
        slideShow_3,
        slideShow_4,
        slideShow_5,
      ]}
      additionalCTA={
        <StyledLink
          href="https://www.youtube.com/watch?v=ojTkW4d_OL8"
          target="_blank"
        >
          <Icon icon={faArrowAltCircleRight} size="lg" />
          {formatMessage(messages.additionalCTAText)}
        </StyledLink>
      }
    />
  );
};
